import React, { Fragment, useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText
} from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, CancelButton, SubmitButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";


export default function UndoDialog({ buttonLoading, setButtonLoading, po_doc_id, poName, status, addSnackbar, fetchPos, undoAction }) {
  const [open, setOpen] = useState(false);
  const [loadingUndo, setLoadingUndo] = useState(false);

  const process = status.includes('Pending Net Sales') ? 'Projections' : 'Net Sales';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingUndo) {
      setOpen(false);
    }
  };

  const undoPoStatus = async (po_doc_id) => {
    handleClose();
    setButtonLoading(true);
    setLoadingUndo(true);
    try {
      await sendRequest(`purchase-orders/undo-status?po_doc_id=${po_doc_id}`);
      fetchPos();
      addSnackbar("Status changed.");
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setButtonLoading(false);
      setLoadingUndo(false);
    }
  }

  return (
    <Fragment>
      <MenuButtonIcon
        isIcon={true}
        title={undoAction}
        text={""}
        icon={UndoIcon}
        iconProps={{ color: 'primary' }}
        variant="text"
        onClick={handleOpen}
        disabled={buttonLoading}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingUndo}
      >
        <CustomDialogTitle
          header={`Undo ${process}`}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to undo ${process}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingUndo}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingUndo}
            text={`Undo ${process}`}
            color="warning"
            onClick={() => undoPoStatus(po_doc_id)}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}
